// removed by extract-text-webpack-plugin
module.exports = {"mobile-header":"MobileNav__mobile-header__3PBJt","back-btn":"MobileNav__back-btn__3Feft","right-btn":"MobileNav__right-btn__3cu5r","mobile-nav":"MobileNav__mobile-nav__2Y4ML"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoting/MobileNav/MobileNav.scss
// module id = 506
// module chunks = 0